import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function StepThree() {
  return (
    <Box>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 4,
          backgroundColor: 'background.default',
        }}>
        <Typography variant="h2">Almost finished.</Typography>
      </Paper>
      <img
        style={{
          height: 255,
          // maxWidth: 400,
          overflow: 'hidden',
          display: 'block',
          width: '100%',
        }}
        src="https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250&q=80"
        alt={'just a label'}
      />
      <Box sx={{p: 2}}>
        <Typography>Hello this is step 3</Typography>
      </Box>
    </Box>
  );
}
